import { AlertManager } from '../utils/AlertManager'

export default class {
	constructor(app) {
		this.app = app
		
		const token = document.head.querySelector('meta[name="csrf-token"]')
		
		window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'
		window.axios.defaults.headers.common['X-CSRF-TOKEN']     = token.content
		window.axios.defaults.baseURL                            = '/api/'
		
		window.axios.interceptors.response.use(response => {
			const token = response.headers.authorization
			
			if(token) {
				window.axios.defaults.headers.common['Authorization'] = `${token}`
			}
			
			return response
		}, error => {
			switch (error.response.status) {
				case 401:
					app['DELETE_TOKEN']()
					break
				default:
					console.log(error.response)
					
					const { errors } = error.response.data
					
					if(errors) {
						for(let e in errors) {
							AlertManager.error(errors[e][0])
							break
						}
						
						return false
					}
					
					if(error.response.status >= 400) {
							AlertManager.error(error.response.data.message)
					}
			}
			
			return Promise.reject(error)
		})
	}
	
	updateToken(token) {
		this.app['SET_ACCESS_TOKEN'](token)
		
		window.axios.defaults.headers.common['Authorization'] = token
	}
}
